import { render, staticRenderFns } from "./profile-updated.vue?vue&type=template&id=d9085e8e&scoped=true&lang=pug&"
import script from "./profile-updated.vue?vue&type=script&lang=js&"
export * from "./profile-updated.vue?vue&type=script&lang=js&"
import style0 from "./profile-updated.vue?vue&type=style&index=0&id=d9085e8e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9085e8e",
  null
  
)

export default component.exports